import { useLang } from "@/i18n";

const Marquee = () => {
  const { t } = useLang();
  const sequence = [...t.marquee, ...t.marquee];

  const Row = () => (
    <div className="flex shrink-0 items-center">
      {sequence.map((word, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic text-4xl md:text-6xl text-ink/20 whitespace-nowrap px-6 md:px-10">
            {word}
          </span>
          <span className="h-2 w-2 rounded-full bg-terracotta/50 shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <div aria-hidden="true" data-testid="editorial-marquee" className="overflow-hidden py-12 md:py-16 select-none border-y border-linen/50">
      <div className="flex w-max animate-marquee motion-reduce:animate-none">
        <Row />
        <Row />
      </div>
    </div>
  );
};

export default Marquee;
